import { MEASUREMENTS_UNITS } from '../constants';

const { IMPERIAL, METRIC } = MEASUREMENTS_UNITS;

export const BRA_SIZE_COUNTRIES_ASIA = [
  'cn',
  'id',
  'in',
  'jp',
  'kr',
  'my',
  'ph',
  'sg',
  'th',
  'tw',
  'vn',
];

export const BRA_SIZE_CALCULATION_TABLE_ASIA = [
  {
    cups: [
      {
        [IMPERIAL]: '7',
        [METRIC]: '18',
        results: {
          alpha: 'XS',
          hybrid: 'XS (D-E)',
        },
      },
      {
        [IMPERIAL]: '7 1/2',
        [METRIC]: '19',
        results: {
          alpha: 'XS',
          hybrid: 'XS (D-E)',
        },
      },
    ],
    underbust: {
      [IMPERIAL]: '25 - 25 1/2',
      [METRIC]: '63 - 65',
    },
  },
  {
    cups: [
      {
        [IMPERIAL]: '6',
        [METRIC]: '16',
        results: {
          alpha: 'XS',
          hybrid: 'XS (A-C)',
        },
      },
      {
        [IMPERIAL]: '6 1/2',
        [METRIC]: '17',
        results: {
          alpha: 'XS',
          hybrid: 'XS (A-C)',
        },
      },
      {
        [IMPERIAL]: '7',
        [METRIC]: '18',
        results: {
          alpha: 'S',
          hybrid: 'S (A-C)',
        },
      },
      {
        [IMPERIAL]: '7 1/2',
        [METRIC]: '19',
        results: {
          alpha: 'S',
          hybrid: 'S (D-E)',
        },
      },
      {
        [IMPERIAL]: '8',
        [METRIC]: '21',
        results: {
          alpha: 'S',
          hybrid: 'S (D-E)',
        },
      },
    ],
    underbust: {
      [IMPERIAL]: '26 - 26 1/2',
      [METRIC]: '66 - 68',
    },
  },
  {
    cups: [
      {
        [IMPERIAL]: '6 1/2',
        [METRIC]: '17',
        results: {
          alpha: 'S',
          hybrid: 'S (A-C)',
        },
      },
      {
        [IMPERIAL]: '7',
        [METRIC]: '18',
        results: {
          alpha: 'S',
          hybrid: 'S (A-C)',
        },
      },
      {
        [IMPERIAL]: '7 1/2',
        [METRIC]: '19',
        results: {
          alpha: 'M',
          hybrid: 'M (A-C)',
        },
      },
      {
        [IMPERIAL]: '8',
        [METRIC]: '21',
        results: {
          alpha: 'M',
          hybrid: 'M (C-E)',
        },
      },
      {
        [IMPERIAL]: '9',
        [METRIC]: '23',
        results: {
          alpha: 'M',
          hybrid: 'M (C-E)',
        },
      },
    ],
    underbust: {
      [IMPERIAL]: '27 - 28 1/2',
      [METRIC]: '69 - 72',
    },
  },
  {
    cups: [
      {
        [IMPERIAL]: '7',
        [METRIC]: '18',
        results: {
          alpha: 'M',
          hybrid: 'M (A-C)',
        },
      },
      {
        [IMPERIAL]: '7 1/2',
        [METRIC]: '19',
        results: {
          alpha: 'M',
          hybrid: 'M (A-C)',
        },
      },
      {
        [IMPERIAL]: '8',
        [METRIC]: '21',
        results: {
          alpha: 'M',
          hybrid: 'M (C-E)',
        },
      },
      {
        [IMPERIAL]: '9',
        [METRIC]: '23',
        results: {
          alpha: 'M',
          hybrid: 'L (C-E)',
        },
      },
      {
        [IMPERIAL]: '9 1/2',
        [METRIC]: '24',
        results: {
          alpha: 'L',
          hybrid: 'L (C-E)',
        },
      },
    ],
    underbust: {
      [IMPERIAL]: '29 - 30',
      [METRIC]: '73 - 77',
    },
  },
  {
    cups: [
      {
        [IMPERIAL]: '7 1/2',
        [METRIC]: '19',
        results: {
          alpha: 'L',
          hybrid: 'L (A-B)',
        },
      },
      {
        [IMPERIAL]: '8',
        [METRIC]: '21',
        results: {
          alpha: 'L',
          hybrid: 'L (A-B)',
        },
      },
      {
        [IMPERIAL]: '9',
        [METRIC]: '23',
        results: {
          alpha: 'L',
          hybrid: 'L (C-E)',
        },
      },
      {
        [IMPERIAL]: '9 1/2',
        [METRIC]: '24',
        results: {
          alpha: 'XL',
          hybrid: 'XL (C-E)',
        },
      },
      {
        [IMPERIAL]: '10',
        [METRIC]: '26',
        results: {
          alpha: 'XL',
          hybrid: 'XL (C-E)',
        },
      },
    ],
    underbust: {
      [IMPERIAL]: '30 1/2 - 32',
      [METRIC]: '78 - 82',
    },
  },
  {
    cups: [
      {
        [IMPERIAL]: '8',
        [METRIC]: '21',
        results: {
          alpha: 'XL',
          hybrid: 'XL (A-B)',
        },
      },
      {
        [IMPERIAL]: '9',
        [METRIC]: '23',
        results: {
          alpha: 'XL',
          hybrid: 'XL (A-B)',
        },
      },
      {
        [IMPERIAL]: '9 1/2',
        [METRIC]: '24',
        results: {
          alpha: 'XL',
          hybrid: 'XL (C-E)',
        },
      },
      {
        [IMPERIAL]: '10',
        [METRIC]: '26',
        results: {
          alpha: '2XL',
          hybrid: '2XL (C-E)',
        },
      },
      {
        [IMPERIAL]: '11',
        [METRIC]: '28',
        results: {
          alpha: '2XL',
          hybrid: '2XL (C-E)',
        },
      },
    ],
    underbust: {
      [IMPERIAL]: '32 1/2 - 34',
      [METRIC]: '83 - 87',
    },
  },
  {
    cups: [
      {
        [IMPERIAL]: '9',
        [METRIC]: '23',
        results: {
          alpha: '2XL',
          hybrid: '2XL (A-B)',
        },
      },
      {
        [IMPERIAL]: '9 1/2',
        [METRIC]: '24',
        results: {
          alpha: '2XL',
          hybrid: '2XL (A-B)',
        },
      },
      {
        [IMPERIAL]: '10',
        [METRIC]: '26',
        results: {
          alpha: '2XL',
          hybrid: '2XL (C-E)',
        },
      },
    ],
    underbust: {
      [IMPERIAL]: '34 1/2 - 36',
      [METRIC]: '88 - 92',
    },
  },
];
